export const DEFAULT_CONFIG = {
    chatbotName: "AWN Chatbot",
    primaryColor: "#172983",
    secondaryColor: "#068945",
    fontFamily: "Roboto",
    logoUrl: "/awn_logo.png",
    language: "de"
};